module.exports = __webpack_public_path__ + "img/ksaq_s.ec1686b.png";